import { ApiUnauthorizedError, ApiTimeoutError, ApiNetworkError } from '../services/claimsApi'

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiUnauthorizedError) return 'Please sign in to continue.'
  if (err instanceof ApiTimeoutError) return (err as Error).message
  if (err instanceof ApiNetworkError) return (err as Error).message
  return fallback
}

const NETWORK_ERROR_PATTERNS = [/aborted/i, /internal error/i, /network/i, /fetch/i, /failed to fetch/i]

export function getAttachmentActionErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiUnauthorizedError) return 'Please sign in to continue.'
  if (err instanceof ApiTimeoutError || err instanceof ApiNetworkError) return 'Network error. Please try again.'
  if (err instanceof Error && NETWORK_ERROR_PATTERNS.some((p) => p.test(err.message))) {
    return 'Network error. Please try again.'
  }
  return fallback
}
